import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-t border-primary/10 bg-background py-16 sm:py-20" aria-labelledby="results-title" data-id="element-107" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-108" data-mp="2d79avywsrafk">
        <SectionHeading id="results-title" data-id="element-109" data-mp="2h81m2xp8bpeh">What <span className="text-accent" data-id="element-110" data-mp="2h70a8r0e2yvp">solar professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-111" data-mp="2m5ld6y70zwnu">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-2xl border border-primary/25 bg-surface p-6 shadow-lg shadow-black/30`} data-id="element-112" data-mp="2r68zx7o81rc9" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-accent" aria-hidden="true" data-id="element-113" data-mp="3nf902hpt3i80" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-114" data-mp="3ilemzx4pi1hw">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/15 pt-4" data-id="element-115" data-mp="3dljwvvsr9fxw">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-background text-sm font-extrabold text-primary" data-id="element-116" data-mp="38mgp43le4vm8">
                  {initials}
                </span>
                <span data-id="element-117" data-mp="8q7kya6wnm1">
                  <b className="block text-sm text-foreground" data-id="element-118" data-mp="7yogmxs4icn">{name}</b>
                  <small className="text-xs text-muted" data-id="element-119" data-mp="3scj00ratnca3">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}